import style from "./home.module.css";
import { Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";
import Action from "./Action";
import CardPage from "./Cardpage";
import Mission from "./Mission";
import Neighbour from "./neighbour";

const ForgottenWomen = () => {

  return (
    <>
      <div className={style.abort_main}>
        <Row style={{ marginRight: "0px" }}>
          <Col md={6} className={style.abortimg}>
            <img
              src="/forgotten.png"
              alt="forgotten"
          
              style={{
                width: "90%",
              }}
            />
          </Col>
          <Col md={6} className={style.bandata}>
            <div className={style.bancol}>
              <h1 className={style.bannerHeading3}>
                Who Are the Forgotten Women?
              </h1>

              <p className={style.bannerHeading2}>
                They are the countless women who faced seemingly insurmountable
                obstacles and felt they had no ‘choice.’ These women, along with
                those grappling with the mental and emotional repercussions,
                have been omitted from the public discourse on the abortion
                debate as if they don’t exist. Their stories and struggles
                deserve to be acknowledged and supported.
              </p>
              <p className={style.bannerHeading2}>
                These women need and deserve our support.
                <p>
                  <span> Their lives matter, too!</span>
                </p>
              </p>
              <div className={style.bannerbutton}>
                <Link to="/donate-to-us/">
                  <button>Stand With Us</button>
                </Link>
              </div>
            </div>
          </Col>
        </Row>
      </div>

      <Action />
      <Neighbour></Neighbour>
      <Mission></Mission>
      <CardPage />
      <div className={style.standcontainer}>
        <img className="w-100" src="/still.jpg" alt="banner" />
        <div className={style.standtext}>
          <h1>I Stand With Them</h1>

          <a href="/letter/">
            {" "}
            <p>Letter from the Founder</p>{" "}
          </a>
        </div>
      </div>

    </>
  );
};

export default ForgottenWomen;
